const Dai = () => (
    <svg
        width='42'
        height='42'
        viewBox='0 0 42 42'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M42 21C42 9.40284 32.599 0 21 0C9.40284 0 0 9.40284 0 21C0 32.5981 9.40284 42 21 42C32.599 42 42 32.599 42 21ZM21.6915 9.76744C23.8874 9.76744 25.8679 10.2641 27.6332 11.2575C29.42 12.2292 30.8193 13.5789 31.8311 15.3065C32.154 15.8578 32.4254 16.43 32.6453 17.0232H35.1628V20.0842H33.3092C33.3356 20.419 33.3488 20.7591 33.3488 21.1046C33.3488 21.4501 33.3353 21.7902 33.3084 22.1249H35.1628V25.1859H32.6304C32.4058 25.7791 32.1286 26.3514 31.7988 26.9028C30.787 28.6304 29.3877 29.9909 27.6009 30.9842C25.8141 31.956 23.812 32.4419 21.5946 32.4419H12.4884V25.1859H9.76744V22.1249H12.4884V20.0842H9.76744V17.0232H12.4884V9.76744H21.6915ZM29.054 16.7641C29.1038 16.8498 29.152 16.9361 29.1985 17.0232H15.5884V12.5855H21.6269C23.22 12.5855 24.6624 12.9635 25.954 13.7193C27.2672 14.4535 28.3006 15.4684 29.054 16.7641ZM15.5884 22.1249V20.0842H30.1287C30.1657 20.4272 30.1842 20.7781 30.1842 21.137C30.1842 21.473 30.1676 21.8023 30.1343 22.1249H15.5884ZM15.5884 25.1859H29.2159C29.164 25.284 29.1101 25.3812 29.054 25.4776C28.3221 26.7733 27.3103 27.7882 26.0186 28.5224C24.7485 29.2566 23.3276 29.6238 21.7561 29.6238H15.5884V25.1859Z'
            fill='white'
        />
    </svg>
);

export default Dai;
